import { rtkAPI } from 'rtk/rtkSetup';
import api from 'util/api';
import enums from 'util/enums';

export const SINGER_TAGS = {
  SIGNER: 'Signer'
};

const enhancedApi = rtkAPI.enhanceEndpoints({
  addTagTypes: [SINGER_TAGS.SIGNER]
});

export const signerApi = enhancedApi.injectEndpoints({
  endpoints: build => ({
    listMasterSigners: build.query({
      async queryFn(args) {
        const {
          skip = 0,
          pageSize = 25,
          keyword = '',
          sortKey = 'FirstName',
          sortOrderAsc = false
        } = args || {};

        const trimmed = (keyword ?? '').trim();
        const effectiveSortKey =
          sortKey === 'IsFavorite' ? 'FirstName' : sortKey;

        const body = {
          MaxResults: pageSize,
          Skip: skip,
          OrderBy: effectiveSortKey,
          OrderDirection: sortOrderAsc ? 'asc' : 'desc',
          IncludeData: false,
          IncludeSubordinates: false,
          ...(trimmed.length > 0 && { Text: trimmed }),
          Filters: {
            ...(sortKey === 'IsFavorite' && { IsFavorite: 1 }),
            IsDeleted: 0
          }
        };

        try {
          const res = await api.Enumeration(
            enums.ENUMERATION_TYPES.SIGNER,
            body
          );
          return { data: res };
        } catch (error) {
          return { error };
        }
      },
      providesTags: [{ type: SINGER_TAGS.SIGNER, id: 'LIST' }]
    }),

    listArchivedSigners: build.query({
      async queryFn(args) {
        const {
          skip = 0,
          pageSize = 25,
          keyword = '',
          sortKey = 'FirstName',
          sortOrderAsc = false
        } = args || {};

        const trimmed = (keyword ?? '').trim();
        const effectiveSortKey =
          sortKey === 'IsFavorite' ? 'FirstName' : sortKey;

        const body = {
          MaxResults: pageSize,
          Skip: skip,
          OrderBy: effectiveSortKey,
          OrderDirection: sortOrderAsc ? 'asc' : 'desc',
          IncludeData: false,
          IncludeSubordinates: false,
          ...(trimmed.length > 0 && { Text: trimmed }),
          Filters: {
            IsDeleted: 1,
            ...(sortKey === 'IsFavorite' && { IsFavorite: 1 })
          }
        };

        try {
          const res = await api.Enumeration(
            enums.ENUMERATION_TYPES.SIGNER,
            body
          );
          return { data: res };
        } catch (error) {
          return { error };
        }
      },
      providesTags: [{ type: SINGER_TAGS.SIGNER, id: 'ARCHIVED_LIST' }]
    })
  })
});

export const { useListMasterSignersQuery, useListArchivedSignersQuery } =
  signerApi;
